module.exports = __webpack_public_path__ + "data/alerts-actions.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/api/alerts-actions/alerts-actions.json
// module id = W13y
// module chunks = 1